// A new file for a third job search service (e.g., Adzuna)
/**
 * Third-Party Job API Service - Example: Adzuna
 */


const ADZUNA_APP_ID = '19256850';
const ADZUNA_APP_KEY = 'db634ec9d6d22dce0c7022a47f5d4544';
const ADZUNA_BASE_URL = 'https://api.adzuna.com/v1/api/jobs/gb/search/1';

/**
 * Check if API key is configured
 */
export function isAdzunaConfigured() {
  return ADZUNA_APP_ID && 
         ADZUNA_APP_KEY && 
         ADZUNA_APP_ID !== 'YOUR_ADZUNA_APP_ID' && 
         ADZUNA_APP_KEY !== 'YOUR_ADZUNA_APP_KEY';
}

/**
 * Helper to standardize Adzuna job data to match other APIs
 */
function transformAdzunaJobs(adzunaJobs = []) {
  return adzunaJobs.map(job => ({
    jobId: job.adref,
    title: job.title,
    description: job.description,
    companyName: job.company.display_name,
    location: job.location.display_name,
    jobSource: 'Adzuna',
    jobUrl: job.redirect_url,
    
    // Convert Adzuna category to a standard type (simplified)
    jobType: job.contract_time 
      ? job.contract_time.charAt(0).toUpperCase() + job.contract_time.slice(1)
      : job.contract_type === 'permanent' ? 'Full-time' : 'Other',
    
    isRemote: job.title.toLowerCase().includes('remote') || (job.location.display_name === 'Anywhere'),
    // Note: Adzuna provides created date, but we'll use a placeholder for age for now
    daysSincePosted: Math.round((new Date() - new Date(job.created)) / (1000 * 60 * 60 * 24)), 
    salary: job.salary_min || job.salary_max || null,
    
    // Add match score for UI consistency
    matchScore: 60 + Math.floor(Math.random() * 40), 
  }));
}


/**
 * Search for jobs using the Adzuna API
 */
export async function searchAdzuna({ query, location, page, remote = false }) {
  if (!isAdzunaConfigured()) {
    return { success: false, jobs: [], error: 'Adzuna API not configured' };
  }

  try {
    // Adzuna API URLSearchParams constructor accepts an array of key-value pairs
    // or an object. The conditional spread is the safest approach here.
    const params = new URLSearchParams({
      app_id: ADZUNA_APP_ID,
      app_key: ADZUNA_APP_KEY,
      results_per_page: 20,
      what: query,
      where: location,
      page: page,
      country: 'gb', 
      'full_time': 1,
      'part_time': 1,
      'contract': 1,
      'temp': 1,
      'permanent': 1,
      // ✅ FIX IS HERE: The spread operator syntax inside the object literal is correct
      // but ensure no misplaced commas outside of it.
      ...(remote && { 'what_and': 'remote' }),
    });

    const url = `${ADZUNA_BASE_URL}/gb/search/1?${params.toString()}`;
    const response = await fetch(url);
    const data = await response.json();

    if (data.error) {
        throw new Error(data.error);
    }

    const transformedJobs = transformAdzunaJobs(data.results);

    return {
      success: true,
      jobs: transformedJobs,
      total: data.count,
    };
  } catch (error) {
    console.error('Adzuna API Error:', error);
    return {
      success: false,
      jobs: [],
      error: error.message,
    };
  }
}